// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__3V3c9","title":"AfterFrontImage_title__2RY1e"};